import React from "react";
import { Link } from "react-router";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { Autoplay } from "swiper/modules";

const SrTwoServiceArea = () => {
  return (
    <>
      <section className="inner-service-two z-3 pt-150">
        <div className="container">
          <div className="row align-items-end mb-80">
            <div className="col-lg-6">
              <div className="section-title mb-30">
                <span
                  className="sub-title wow fadeInRight"
                  data-wow-duration=".7s"
                >
                  WHAT WE OFFER
                </span>
                <h3 className="title xb-split-text split-in-right">
                  Unlock Revenue Growth for Your <span>Business</span>
                </h3>
              </div>
            </div>
          </div>
        </div>
        <div className="service-slider">
          <Swiper
            slidesPerView={4}
            spaceBetween={0}
            loop={true}
            autoplay={{
              delay: 6000,
              disableOnInteraction: true,
            }}
            roundLengths={true}
            modules={[Autoplay]}
            speed={400}
            breakpoints={{
              1600: { slidesPerView: 4 },
              1200: { slidesPerView: 3 },
              992: { slidesPerView: 3 },
              768: { slidesPerView: 2 },
              576: { slidesPerView: 2 },
              0: { slidesPerView: 1 },
            }}
            className="swiper-wrapper"
          >
            <SwiperSlide className="swiper-slide xb-service2">
              <div className="xb-item--inner">
                <div className="xb-item--image">
                  <img
                    src="./assets/img/about/om-smm-social-media-mangaement.webp"
                    alt=""
                  />
                  <div className="xb-item--content">
                    <h2 className="xb-item--title">
                      <Link to="/social-media-management">
                        Social Media Management
                      </Link>
                    </h2>
                    <span className="xb-item--sub-title">
                      Crafting Impactful Digital Stories for Maximum Engagement
                    </span>
                  </div>
                </div>
                <Link
                  to="/social-media-management"
                  className="xb-overlay xb-overlay-link"
                ></Link>
              </div>
            </SwiperSlide>
            <SwiperSlide className="swiper-slide xb-service2">
              <div className="xb-item--inner">
                <div className="xb-item--image">
                  <img
                    src="./assets/img/about/om-digital-marketing.webp"
                    alt=""
                  />
                  <div className="xb-item--content">
                    <h2 className="xb-item--title">
                      <Link to="/digital-marketing">Digital Marketing</Link>
                    </h2>
                    <span className="xb-item--sub-title">
                      Driving Growth with Data-Driven Strategies and Creative
                      Campaigns
                    </span>
                  </div>
                </div>
                <Link
                  to="/digital-marketing"
                  className="xb-overlay xb-overlay-link"
                ></Link>
              </div>
            </SwiperSlide>
            <SwiperSlide className="swiper-slide xb-service2">
              <div className="xb-item--inner">
                <div className="xb-item--image">
                  <img
                    src="./assets/img/about/om-web-development.webp"
                    alt=""
                  />
                  <div className="xb-item--content">
                    <h2 className="xb-item--title">
                      <Link to="/web-development">Web Development</Link>
                    </h2>
                    <span className="xb-item--sub-title">
                      Building Seamless and Scalable Digital Experiences
                    </span>
                  </div>
                </div>
                <Link
                  className="xb-overlay xb-overlay-link"
                  to="/web-development"
                ></Link>
              </div>
            </SwiperSlide>
          </Swiper>
        </div>
      </section>
    </>
  );
};

export default SrTwoServiceArea;
